import { RefObject, useEffect } from "react";

export function useScrollIntoViewOnAppearance<T extends HTMLElement>(
  ref: RefObject<T>,
  enabled: boolean
) {
  useEffect(() => {
    const { current } = ref;
    if (current && enabled) {
      current.scrollIntoView();
      const { activeElement } = document;
      if (activeElement) {
        const { parentElement } = activeElement;
        (parentElement instanceof HTMLLabelElement
          ? parentElement
          : activeElement
        ).scrollIntoView();
      }
    }
  }, [ref, enabled]);
}
